// @flow
import React from 'react';
import icon from './report.svg';
import './styles.css';

export default function Placeholder() {
  return (
    <img
      className="Placeholder"
      src={icon}
      alt="Simulador de Préstamos"
      title="Simulador de Préstamos" />
  );
}
